import axios from 'axios';
import configSettings from './../config.js';

const getHeaders = () => {
  const ldapHeader = {
    'Authorization': `Bearer ${localStorage.getItem("vpToken")}`,
     Pragma: 'no-cache'
  };

  let instance;

    instance = axios.create({
      headers: {
        ...ldapHeader,
      },
    });
    instance.interceptors.response.use(response => {
      return response;
    }, error => {
     if (error.response.status === 401 ) {
      localStorage.removeItem("vpToken");
      localStorage.removeItem("fName");
      localStorage.removeItem("lName");
      localStorage.removeItem("vendorName");
      window.open('https://sso.blinds.com/dag/saml2/idp/SSOService.php?spentityid='+configSettings.serviceProviderEntityId,'_self')
     }


     return error;
    });

  return instance;
};



const createInstanceWithApiKey = () => getHeaders();

const createInstance = () => (axios);





export const Axios = {
  createInstanceWithApiKey,
  createInstance,
};
